import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {PlayerPrefs} from '../classes/PlayerPrefs.js';
import {AudioManager, globalAudioManager} from '@wonderlandengine/spatial-audio';
import {Sounds} from '../enums/Sounds.js';

const MUSIC_ENABLED_KEY = 'MusicEnabled';

const music = 'audio/music/';

export class MusicDirector extends Component {
    static TypeName = 'music-director';

    // Singleton
    private static _instance: MusicDirector;
    private _loadingPromise: Promise<void[]> | Promise<void>;
    static get instance(): MusicDirector {
        return MusicDirector._instance;
    }

    @property.float(0.4)
    musicVolume = 0.4;

    private _currentPlayingId: number = 0;
    private _song: Sounds = Sounds.none;
    private _musicEnabled: boolean = false;

    private get _audioManager(): AudioManager {
        return globalAudioManager as AudioManager;
    }

    get musicEnabled(): boolean {
        return this._musicEnabled;
    }
    set musicEnabled(value: boolean) {
        if (this._musicEnabled !== value) {
            this._musicEnabled = value;
            if (!this._musicEnabled && this._song !== Sounds.none) {
                this.stopImmediate();
            } else if (this._song != Sounds.none) {
                this.play(this._song);
            }

            PlayerPrefs.setBool(MUSIC_ENABLED_KEY, value);
        }
    }

    init() {
        if (MusicDirector._instance) {
            console.error('There can only be one instance of MusicDirector Component');
        }
        MusicDirector._instance = this;
        this._loadingPromise = globalAudioManager.loadBatch(
            [music + 'Song 1 Slow.mp3', Sounds.Song1Slow],
            [music + 'Song 3 Slow.mp3', Sounds.Song3Slow],
            [music + 'Song 4 Slow.mp3', Sounds.Song4Slow],
            [music + 'Song 5 Slow.mp3', Sounds.Song5Slow],
            [music + 'Song 1 and 2 Fast.mp3', Sounds.Song1And2Fast],
            [music + 'ROTB-Title.mp3', Sounds.MusicTitle]
        );

        this._musicEnabled = PlayerPrefs.getBool(MUSIC_ENABLED_KEY, true);
    }

    start() {}

    play(song: Sounds) {
        if (this._loadingPromise) {
            this._loadingPromise.then(() => {
                this._loadingPromise = null;
                this.play(song);
            });
            return;
        }

        if (!navigator.userActivation.hasBeenActive) {
            // Don't play music if the user hasn't interacted with the page yet
            return;
        }

        this.stopImmediate();
        this._song = song;
        if (!this._musicEnabled) return;
        try {
            this._currentPlayingId = this._audioManager.play(song, {
                channel: 1,
                volume: this.musicVolume,
                loop: true,
                priority: true,
            });
        } catch (e) {
            //TK: Converting the error to a warning for now.
            console.warn(e);
        }
    }

    pause() {
        if (this._song === Sounds.none || !this._musicEnabled) {
            // can't pause if nothing was playing and no need to pause if music is disabled
            return;
        }
        this._audioManager.pause(this._currentPlayingId);
    }

    resume() {
        if (this._song === Sounds.none || !this._musicEnabled) {
            // can't resume if nothing was playing and no need to resume if music is disabled
            return;
        }
        this._audioManager.resume(this._currentPlayingId);
    }

    stopImmediate() {
        this._audioManager.stop(this._currentPlayingId);
    }
}
